import { Card } from "../ui/card";
import { useState } from "react";

const OnlyFansTerms = (): JSX.Element => {
  const [selectedTerm, setSelectedTerm] = useState<number | null>(null);

  return (
    <div className="space-y-6">
      <div className="flex flex-col space-y-1.5 pb-4 border-b">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-brand-dark dark:text-foreground">
          OnlyFans Terms
        </h1>
        <p className="text-muted-foreground dark:text-muted-foreground">
          Read these important content guidelines carefully. These terms ensure compliance 
          with platform policies. Failure to comply may result in your termination.
        </p>
      </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(15)].map((_, index) => (
              <Card 
                key={index + 1} 
                className={`p-4`}
                onClick={() => setSelectedTerm(selectedTerm === index + 1 ? null : index + 1)}
              >
                <div className="flex gap-4 items-start">
                  <span className="text-sm font-medium text-muted-foreground mt-1.5 w-6 text-right shrink-0">
                    {(index + 1).toString().padStart(2, '0')}
                  </span>
                  <div className="space-y-2 flex-1">
                    <h2 className="text-base font-semibold text-foreground">
                      {getTitleForIndex(index + 1)}
                    </h2>
                    <div className="space-y-2">
                      {getContentForIndex(index + 1).map((content, i) => (
                        <p 
                          key={i} 
                          className="text-sm text-muted-foreground leading-relaxed"
                        >
                          • {content}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
    </div>
  );
};

const getTitleForIndex = (index: number): string => {
  const titles: Record<number, string> = {
    1: 'Non-Consensual or Forced Acts',
    2: 'Extreme BDSM and Violence',
    3: 'Content Involving Minors',
    4: 'Bestiality and Zoophilia',
    5: 'Incest-Themed Content',
    6: 'Necrophilia',
    7: 'Restricted Bodily Fluids',
    8: 'Public Sex and Exhibitionism',
    9: 'Drug-Related Content',
    10: 'Extreme Financial Domination',
    11: 'Hate Speech and Discrimination',
    12: 'Prostitution and Escort Services',
    13: 'AI-Generated Content',
    14: 'Prohibited Words and Terms',
    15: 'Off-Platform Activities'
  };
  return titles[index] || '';
};

const getContentForIndex = (index: number): string[] => {
  const content: Record<number, string[]> = {
    1: [
      'Any depiction of non-consensual sex, including roleplay scenarios',
      'Content involving unconsciousness, intoxication, hypnosis, or coercion',
      'Terms like "rape," "forced," "coercion," "unwilling" are prohibited',
      'No "passed out" or "unconscious" content'
    ],
    2: [
      'No practices causing physical harm',
      'Ballbusting or CBT (cock and ball torture) is prohibited',
      'No extreme spanking or breathplay',
      'Anal or vaginal fisting is not allowed',
      'Sadomasochistic abuse or torture is forbidden',
      'Terms like "choking" and "crying" are banned',
      'No "torture," "mutilation," or "snuff" content'
    ],
    3: [
      'Any depiction of individuals under 18 years old is strictly forbidden',
      'No roleplay scenarios suggesting underage characters',
      'Avoid terms like "teen," "jailbait," or similar',
      'Do not use numerical ages below 18',
      'Replace "little" with "petite" to avoid misinterpretation'
    ],
    4: [
      'No sexual content involving animals',
      'No roleplay or costumes implying human-animal sexual relationships',
      'Terms like "bestiality" and "zoophilia" are prohibited',
      'Avoid references to animals in sexual contexts'
    ],
    5: [
      'No depictions of sexual activity between family members, real or fictional',
      'Terms like "incest" or "inbreeding" are prohibited',
      '"Daddy" or "mommy" and "step-" terms are allowed',
      'Do not use "mother," "brother," "daughter," "uncle," etc.'
    ],
    6: [
      'No sexual content involving corpses',
      'No pretending to be dead or unconscious',
      'Terms suggesting death or unconsciousness are prohibited'
    ],
    7: [
      'Content involving feces, urine, blood, or fart is prohibited',
      'No "scat," "piss," or "golden showers"',
      'Terms like "vomit," "enema," "menstruation," "lactation" are banned'
    ],
    8: [
      'No sexual acts performed in public spaces',
      'No content where bystanders could witness',
      'No content filmed without proper permissions in public areas'
    ],
    9: [
      'No depictions of drug use or paraphernalia',
      'No content showing individuals under the influence',
      'Terms like "drugs," "cocaine," "heroin," "meth" are prohibited'
    ],
    10: [
      'No demanding personal financial information',
      'No property transfers',
      'No blackmail or coercive financial practices'
    ],
    11: [
      'No content promoting hate speech or discrimination',
      'No harassment based on race, gender, sexuality, or other protected characteristics',
      'No racial slurs or discriminatory language'
    ],
    12: [
      'No promotion of escort services or sex trafficking',
      'No prostitution-related content',
      'Do not promise meet-ups in any way or form'
    ],
    13: [
      'AI-generated content can only be used by the model herself',
      'Written consent required for AI content',
      'No AI-generated content from chatters',
      'No deepfakes or AI-generated content featuring individuals without consent'
    ],
    14: [
      'Do not use emojis or creative spellings to bypass restrictions',
      'Maintain professional communication even in adult interactions',
      'No hate speech or discriminatory remarks'
    ],
    15: [
      'Do not mention other adult platforms like Fansly or ManyVids',
      'No promotion of payment services (PayPal, CashApp, Venmo)',
      'No references to external communication apps (WhatsApp, Telegram)'
    ]
  };
  return content[index] || [];
};

export default OnlyFansTerms; 